<template>
<div class="chapter">
<div class="inner_page">
<h1 class="half-title"><a id="page_3"></a>The</h1>
<h1 class="half-title2">Second World War</h1>
<h1 class="half-title2">Illustrated</h1>
<p class="half-title1"><em class="italic">The Third Year</em></p>
<p class="author">J<span class="small">ACK</span> H<span class="small">OLROYD</span></p>
<div class="img_container">
<p class="logo1"><img alt="Image" src="images/logo1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?35471aa1